import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("monitoring.no_metadata"))),
      ]),
      _vm._t("default"),
      _c("actions-component", {
        attrs: { class_table: _vm.getClass },
        scopedSlots: _vm._u([
          {
            key: "description",
            fn: function () {
              return [
                _c(VBreadcrumbs, {
                  staticClass: "pa-0",
                  attrs: { items: _vm.getBreadcrumbs },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _vm.showAsyncData
                  ? _c(
                      VTooltip,
                      {
                        attrs: { bottom: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function (ref) {
                                var attrs = ref.attrs
                                var on = ref.on
                                return [
                                  _c(
                                    VBtn,
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass:
                                            "ml-1 btn-inca-secondary",
                                          attrs: { outlined: "", dense: "" },
                                          on: { click: _vm.onDownloadCSV },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [
                                      _c(VIcon, { attrs: { small: "" } }, [
                                        _vm._v("icon-download"),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("btns.download")) +
                                          " "
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4161522092
                        ),
                      },
                      [
                        _c("span", [
                          _vm._v(" " + _vm._s(_vm.$t("btns.download")) + " "),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _c(
                  VTooltip,
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "activator",
                        fn: function (ref) {
                          var attrs = ref.attrs
                          var on = ref.on
                          return [
                            _c(
                              VBtn,
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass: "ml-1 btn-inca-secondary",
                                    attrs: { outlined: "", dense: "" },
                                    on: { click: _vm.onEnableFilter },
                                  },
                                  "v-btn",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [
                                _vm.filterEnabled
                                  ? _c(VIcon, { attrs: { small: "" } }, [
                                      _vm._v("mdi-filter-off-outline"),
                                    ])
                                  : _vm._e(),
                                !_vm.filterEnabled
                                  ? _c(VIcon, { attrs: { small: "" } }, [
                                      _vm._v("mdi-filter-outline"),
                                    ])
                                  : _vm._e(),
                                _vm._v(
                                  " " + _vm._s(_vm.$t("btns.filter")) + " "
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  },
                  [
                    _c("span", [
                      _vm._v(" " + _vm._s(_vm.$t("btns.filter")) + " "),
                    ]),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(VRow, [
        _c(
          "div",
          { class: _vm.getClass },
          [
            _c(
              VCard,
              [
                _c(VDataTable, {
                  directives: [
                    { name: "scrollable-table", rawName: "v-scrollable-table" },
                  ],
                  key: _vm.keyTable,
                  staticClass: "text-center table-inca",
                  attrs: {
                    responsive: "",
                    hover: "",
                    items: _vm.items,
                    headers: _vm.headers,
                    "hide-default-footer": "",
                    "items-per-page": _vm.pagination.limit,
                    page: _vm.pagination.current,
                  },
                  on: {
                    pagination: function ($event) {
                      _vm.pagination.total = $event.itemsLength
                    },
                    "update:page": function ($event) {
                      return _vm.$set(_vm.pagination, "current", $event)
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "item.actions",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          _c(
                            VTooltip,
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var attrs = ref.attrs
                                      var on = ref.on
                                      return [
                                        _c(
                                          VBtn,
                                          _vm._g(
                                            _vm._b(
                                              {
                                                attrs: { small: "", icon: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.syncTable(item)
                                                  },
                                                },
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c(
                                              VIcon,
                                              { attrs: { small: "" } },
                                              [_vm._v("mdi-restore")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("span", [
                                _vm._v(" " + _vm._s(_vm.$t("btns.sync")) + " "),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c("pagination-catalog", {
              key: _vm.keyPagination,
              attrs: { pagination: _vm.pagination },
              on: { changePagina: _vm.changePage },
            }),
          ],
          1
        ),
        _vm.filterEnabled
          ? _c(
              "div",
              {
                staticClass:
                  "order-md-last order-first col-md-3 col-12 pl-md-0 mb-2",
              },
              [
                _c(
                  VCard,
                  { staticClass: "filters-inca" },
                  [
                    _c(VCardTitle, { staticClass: "pointer" }, [
                      _vm._v(
                        " " + _vm._s(_vm.$t("monitoring.search_filters")) + " "
                      ),
                    ]),
                    _c(
                      VCardText,
                      { attrs: { claas: "pa-2" } },
                      [
                        _c(
                          VRow,
                          { attrs: { dense: "" } },
                          [
                            _c(
                              VCol,
                              { attrs: { cols: "12" } },
                              [
                                _vm.isDomainItc
                                  ? _c("organizacion-component", {
                                      attrs: { show_all: false },
                                      model: {
                                        value: _vm.domainFilter,
                                        callback: function ($$v) {
                                          _vm.domainFilter = $$v
                                        },
                                        expression: "domainFilter",
                                      },
                                    })
                                  : _vm._e(),
                                _c(VSelect, {
                                  attrs: {
                                    outlined: "",
                                    dense: "",
                                    label: _vm.translate(
                                      "monitoring.search_project"
                                    ),
                                    items: _vm.projects[_vm.domainFilter],
                                  },
                                  model: {
                                    value: _vm.dataFilter.projectid,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.dataFilter, "projectid", $$v)
                                    },
                                    expression: "dataFilter.projectid",
                                  },
                                }),
                                _c(VTextField, {
                                  attrs: {
                                    outlined: "",
                                    dense: "",
                                    label: _vm.translate(
                                      "monitoring.search_dataset"
                                    ),
                                    placeholder: _vm.translate(
                                      "monitoring.search_dataset"
                                    ),
                                  },
                                  model: {
                                    value: _vm.dataFilter.parent,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.dataFilter, "parent", $$v)
                                    },
                                    expression: "dataFilter.parent",
                                  },
                                }),
                                _c(VTextField, {
                                  attrs: {
                                    outlined: "",
                                    dense: "",
                                    label: _vm.translate(
                                      "monitoring.search_table"
                                    ),
                                    placeholder: _vm.translate(
                                      "monitoring.search_table"
                                    ),
                                  },
                                  model: {
                                    value: _vm.dataFilter.name,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.dataFilter, "name", $$v)
                                    },
                                    expression: "dataFilter.name",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              {
                                staticClass: "text-right",
                                attrs: { cols: "12" },
                              },
                              [
                                _c(
                                  VBtn,
                                  {
                                    staticClass: "default mr-1",
                                    attrs: { outlined: "" },
                                    on: { click: _vm.onCleanSearch },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("btns.clean")))]
                                ),
                                _c(
                                  VBtn,
                                  {
                                    staticClass: "primary",
                                    on: { click: _vm.onSearch },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("btns.search")))]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }